module.exports = __webpack_public_path__ + "img/sample-facilities.90527cf2.svg";